import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieBanner.css';

const CONSENT_KEY = 'gormaran_consent_v2';

function getStoredConsent() {
  try { return JSON.parse(localStorage.getItem(CONSENT_KEY)); } catch { return null; }
}

function saveConsent(c) {
  localStorage.setItem(CONSENT_KEY, JSON.stringify({ ...c, ts: Date.now() }));
  if (window.gormaran_updateConsent) window.gormaran_updateConsent(c);
}

export default function CookieBanner() {
  const [visible, setVisible]       = useState(false);
  const [expanded, setExpanded]     = useState(false);
  const [prefs, setPrefs]           = useState({ analytics: true, marketing: true });

  useEffect(() => {
    if (!getStoredConsent()) setVisible(true);
  }, []);

  if (!visible) return null;

  function acceptAll() {
    const c = { functional: true, analytics: true, marketing: true };
    saveConsent(c);
    setVisible(false);
  }

  function rejectAll() {
    const c = { functional: true, analytics: false, marketing: false };
    saveConsent(c);
    setVisible(false);
  }

  function saveCustom() {
    const c = { functional: true, analytics: prefs.analytics, marketing: prefs.marketing };
    saveConsent(c);
    setVisible(false);
  }

  return (
    <div className="cookie-banner" role="dialog" aria-label="Aviso de cookies">
      <div className="cookie-banner__inner">
        <div className="cookie-banner__text">
          <strong>🍪 Usamos cookies</strong>
          <p>
            Necesitamos tu consentimiento para usar cookies de analítica y marketing.
            Las cookies esenciales siempre están activas (necesarias para que la web funcione).{' '}
            <Link to="/cookie-policy" className="cookie-banner__link">Política de cookies</Link>
            {' · '}
            <Link to="/privacy-policy" className="cookie-banner__link">Privacidad</Link>
          </p>
        </div>

        {!expanded ? (
          <div className="cookie-banner__actions">
            <button className="cookie-banner__btn cookie-banner__btn--accept" onClick={acceptAll}>
              Aceptar todo
            </button>
            <button className="cookie-banner__btn cookie-banner__btn--reject" onClick={rejectAll}>
              Solo esenciales
            </button>
            <button className="cookie-banner__btn cookie-banner__btn--custom" onClick={() => setExpanded(true)}>
              Personalizar
            </button>
          </div>
        ) : (
          <div className="cookie-banner__custom">
            <div className="cookie-banner__pref">
              <div>
                <span className="cookie-banner__pref-name">Esenciales</span>
                <span className="cookie-banner__pref-desc">Autenticación, preferencias, carrito. Siempre activas.</span>
              </div>
              <input type="checkbox" checked disabled aria-label="Cookies esenciales siempre activas" />
            </div>
            <div className="cookie-banner__pref">
              <div>
                <span className="cookie-banner__pref-name">Analítica</span>
                <span className="cookie-banner__pref-desc">Google Analytics, ContentSquare. Mejoran la experiencia sin identificarte.</span>
              </div>
              <input
                type="checkbox"
                checked={prefs.analytics}
                onChange={e => setPrefs(p => ({ ...p, analytics: e.target.checked }))}
                aria-label="Cookies de analítica"
              />
            </div>
            <div className="cookie-banner__pref">
              <div>
                <span className="cookie-banner__pref-name">Marketing</span>
                <span className="cookie-banner__pref-desc">Google Ads, Meta Pixel. Miden conversiones y muestran anuncios relevantes.</span>
              </div>
              <input
                type="checkbox"
                checked={prefs.marketing}
                onChange={e => setPrefs(p => ({ ...p, marketing: e.target.checked }))}
                aria-label="Cookies de marketing"
              />
            </div>
            <div className="cookie-banner__custom-actions">
              <button className="cookie-banner__btn cookie-banner__btn--accept" onClick={saveCustom}>
                Guardar preferencias
              </button>
              <button className="cookie-banner__btn cookie-banner__btn--reject" onClick={rejectAll}>
                Rechazar todo
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
